import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.ShareFileModal.title',
    defaultMessage: 'Share file',
  },
  cancel: {
    id: 'components.ShareFileModal.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'components.ShareFileModal.loading',
    defaultMessage: 'Loading..',
  },
  submit: {
    id: 'components.ShareFileModal.submit',
    defaultMessage: 'Close',
  },
  sideEffects: {
    id: 'components.ShareFileModal.sideEffects',
    defaultMessage: `
      <li></li>
      <li></li>
    `
  },
  copyLinkSuccess: {
    id: 'components.ShareFileModal.copyLinkSuccess',
    defaultMessage: 'Link copied to clipboard',
  },
  publicLinkTitle: {
    id: 'components.ShareFileModal.publicLinkTitle',
    defaultMessage: 'Public Link',
  },
  publicLinkDescription: {
    id: 'components.ShareFileModal.publicLinkDescription',
    defaultMessage: 'Will trigger status changes and download state changes',
  },
  anonymousLinkTitle: {
    id: 'components.ShareFileModal.anonymousLinkTitle',
    defaultMessage: 'Anonymous Link',
  },
  anonymousLinkDescription: {
    id: 'components.ShareFileModal.anonymousLinkDescription',
    defaultMessage: 'Will not trigger status changes or downloaded state',
  },
})
